import { cva } from 'class-variance-authority'

/** Shared look for text-like controls (input, textarea, select). */
export const controlVariants = cva(
  'w-full rounded-control border bg-surface text-sm text-ink shadow-xs transition-[border-color,box-shadow] duration-150 placeholder:text-subtle hover:border-line-strong focus:border-brand-400 focus:ring-4 focus:ring-brand-500/15 focus:outline-none disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-muted aria-invalid:border-danger-500 aria-invalid:focus:ring-danger-500/15',
  {
    variants: {
      size: { sm: 'h-8 px-2.5 text-xs', md: 'h-10 px-3', lg: 'h-11 px-3.5' },
      tone: { default: 'border-line' },
    },
    defaultVariants: { size: 'md', tone: 'default' },
  },
)
